module.exports = __webpack_public_path__ + "img/works_tiger_e_btm_off.269d6edd.jpg";